





















































































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import STextarea from '@/common/components/STextarea.vue';
import STextareaShort from '@/common/components/STextareaShort.vue';
import TableInput from '@/tasks/components/inputs/TableInput.vue';

export default defineComponent({
  name: 'UCIrvineChem1LDLabReport3DataAnalysis',
  components: {TableInput, STextarea, StembleLatex},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        additionalObservations: '',
        characterizationTest1: null,
        characterizationTest2: null,
        characterizationTest3: null,
        characterizationTest4: null,
        tableRows: [
          {
            a: '',
            b: '',
            c: '',
            d: '',
            e: '',
          },
          {
            a: '',
            b: '',
            c: '',
            d: '',
            e: '',
          },
        ],
      },
      characterizationTests: [
        'Percent Yield',
        'Solubility',
        'Melting Point',
        'TLC',
        'Absorption Spectrum',
        'Molecular Weight by Freezing Point Depression',
      ],
      columns: [
        {
          label: 'Column 1',
          component: STextareaShort,
          prop: 'a',
          width: '20%',
        },
        {
          label: 'Column 2',
          component: STextareaShort,
          prop: 'b',
          width: '20%',
        },
        {
          label: 'Column 3',
          component: STextareaShort,
          prop: 'c',
          width: '20%',
        },
        {
          label: 'Column 4',
          component: STextareaShort,
          prop: 'd',
          width: '20%',
        },
        {
          label: 'Column 5',
          component: STextareaShort,
          prop: 'e',
          width: '20%',
        },
      ],
      attachments: [] as File[],
      questions: [
        {
          text: 'In the space below, please include all remaining data analysis including all relevant data, calculations, reported values, etc.',
          inputName: 'additionalObservations',
          maxInputLength: 2000,
        },
      ],
    };
  },
});
